import React, { memo } from "react";
import useStyles from "../../styles";
import ProductItem from "../ProductItem";
import PromotionDetail from "../PromotionDetail";
import PointLoyalty from "../PointLoyalty";

import { Grid } from "@material-ui/core";

const BodyCart = memo(props => {
	const classes = useStyles();

	const {
		handleOnFocus,
		heightWrapperCart,
		wallet,
		listProductOrder,
		listProductSelect,
		setListProductSelect,
		handleDeleteProduct,
		isShowKeyboard,
		setIsShowKeyboard,
		campaigns
	} = props;

	return (
		<Grid
			classes={{ root: classes.rootBodyPage }}
			style={{
				height: `calc(100vh - ${heightWrapperCart}px)`
			}}
		>
			<Grid style={{ padding: 16 }}>
				{listProductOrder?.length > 0 &&
					listProductOrder?.map(product => (
						<ProductItem
							key={product?.id}
							product={product}
							listProductSelect={listProductSelect}
							setListProductSelect={setListProductSelect}
							handleDeleteProduct={handleDeleteProduct}
							handleOnBlur={() => {
								handleOnFocus();
							}}
							handleOnFocus={() => {
								if (!isShowKeyboard) {
									setIsShowKeyboard(true);
								}
							}}
						/>
					))}
				{campaigns?.length > 0 && (
					<Grid classes={{ root: classes.promotion }}>
						<Grid
							classes={{
								root: classes.titlePromotion
							}}
						>
							Khuyến mãi
						</Grid>
						{campaigns?.map(campaign => {
							return (
								<React.Fragment key={campaign?.id}>
									{campaign?.promotions?.map(promotion => (
										<PromotionDetail
											campaign={campaign}
											promotion={promotion}
											key={promotion?.id}
										/>
									))}
								</React.Fragment>
							);
						})}
					</Grid>
				)}
				{wallet?.pointByCart > 0 && (
					<PointLoyalty point={wallet?.pointByCart || 0} />
				)}
			</Grid>
		</Grid>
	);
});

export default BodyCart;
